module.exports = __webpack_public_path__ + "static/media/Close.c103e25b.svg";